module.exports = __webpack_public_path__ + "static/media/ktmn.d0cb57f9.png";